import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { OccupationModel } from '@app/ps/models/occupation.model';
import { Restangular } from 'ngx-restangular';
import { ExpertModel } from '@app/ps/models/expert.model';
import { SwitchOption } from '@app/common/components/switch/switch.component';
import { AuthService } from '@app/common/services/auth.service';
import { BrandService } from "@app/common/services/brand.service";

@Component({
  templateUrl: './update-occupation.component.html',
  styleUrls: ['./update-occupation.component.scss'],
})
export class UpdateOccupationComponent implements OnInit {
  @Input() titleId: number;
  @Input() parcelId: number;
  @Input() occupationId: number;
  public occupationTypeName: string;

  occupationObject: OccupationModel;
  public priceType: SwitchOption[];
  public priceUnit: SwitchOption[];
  public priorityOptions = [];
  public priorityHolder = { priorityIndex: null };
  private priceAssesment;

  public occupationSolutionOptions = [
    {id: null, value: 'Jiný způsob řešení'},
    {id: 'permanentWithSolutionTypeUnderOneYear', value: 'Nájem do 1 roku'},
    {id: 'permanentWithSolutionTypeOverOneYear', value: 'Nájem nad 1 rok'},
  ];

  constructor(
    private stateService: StateService,
    private restangular: Restangular,
    private authService: AuthService,
    private brandService: BrandService,
  ) {
    this.goToDetail = this.goToDetail.bind(this);
    this.update = this.update.bind(this);
    this.priceType = [
      {
        value: 'Cenový výměr ministerstva financí',
        id: 'F',
      },
      {
        value: 'Znalecký posudek',
        id: 'E',
      },
      {
        value: 'Jiný způsob',
        id: 'O',
      },
    ];

    this.priceUnit = [
      {
        value: 'Roční cena za metr čtvereční',
        id: 'A',
      },
      {
        value: 'Jednorázová cena',
        id: 'T',
      },
    ];
  }

  async ngOnInit() {
    await this.loadOccupation();
  }

  public onRentalPriceTypeChange(newValue) {
    this.occupationObject.rentalPriceType = newValue;
    this.updateAssessment();
  }

  updateAssessment() {
    if (this.priceAssesment && this.occupationObject.rentalPriceType === 'F') {
        this.occupationObject.priceAssessmentYear = this.priceAssesment.year;
        this.occupationObject.priceAssessmentPrice = this.priceAssesment.prices.find(p => p.areaId === this.occupationObject.parcel.katuzeKod);
        this.occupationObject.priceAssessmentLandPrice = this.occupationObject.priceAssessmentPrice ? this.occupationObject.priceAssessmentPrice.price : null;
    }
  }

  async loadOccupation() {
    this.occupationObject = await this.restangular.one('occupations', this.occupationId).get({loadCollections: ['rentalExpert', 'priceAssessmentPrice']}).toPromise();
    this.priceAssesment = await this.restangular.all('price-assessments').all('list').customPOST().toPromise().then(r => {
      return r[r.length-1];
    });
    this.occupationObject.rentalPriceType = this.occupationObject.rentalPriceType || 'F';
    this.occupationObject.rentalPriceUnit = this.occupationObject.rentalPriceUnit || 'A';
    if (this.occupationObject.solutionType === 'permanentWithSolutionUnderOneYear') {
      this.occupationObject.rentalLength = this.occupationObject.rentalLength || 12;
    }
    this.occupationObject.solutionType = this.occupationObject.solutionType || null;
    this.occupationObject.priorityIndex = this.occupationObject.priorityIndex || 0;
    this.occupationTypeName = this.occupationLongerThanOneYear() ? 'Dočasný zábor nad 1 rok' : (this.occupationShorterThanOneYear() ? 'Dočasný zábor do 1 roku' : this.occupationObject.zabtyptx);
    this.updateAssessment();

    const project = this.authService.getActualProject();
    if (project && project.occupationsPriority && project.occupationsPriority.enabled) {
      this.priorityOptions = project.occupationsPriority.categories
        .map((c: any, i: number) => ({ id: i, name: c.name }));
      this.priorityHolder.priorityIndex = this.priorityOptions
        .find(o => o.id === (this.occupationObject.priorityIndex ? this.occupationObject.priorityIndex : 0)) || this.priorityOptions[0];
    }
  }

  goToDetail() {
     this.stateService.go('^', {tab: this.titleId ? 'parcels' : 'occupations'});
  }

  async update() {
    this.occupationObject.priorityIndex = this.priorityHolder.priorityIndex ? this.priorityHolder.priorityIndex.id : 0;
    await (<any>this.occupationObject)
          .put().toPromise();
    this.goToDetail();
  }

  onChangeExpert(expert: ExpertModel) {
    this.occupationObject.rentalExpert = expert;
  }

  isSolutionType(): boolean {
    return ((
      this.occupationObject.zabtyp == 3 || this.occupationObject.zabtyp == 7 ||
      this.occupationObject.zabtyp == 12 || this.occupationObject.zabtyp == 121 ||
      this.occupationObject.zabtyp == 122) && !this.brandService.isVisible('mpv'))
  }

  isValid() {
    return (!this.occupationObject.solutionType && !this.occupationLongerThanOneYear() && !this.occupationShorterThanOneYear()) ||
     (this.occupationObject.rentalPriceType && this.occupationObject.rentalLength > 0 &&
       (
        ((this.occupationLongerThanOneYear() || this.occupationObject.solutionType === 'permanentWithSolutionTypeOverOneYear') && this.occupationObject.rentalLength > 12) ||
        ((this.occupationShorterThanOneYear() || this.occupationObject.solutionType === 'permanentWithSolutionTypeUnderOneYear') && this.occupationObject.rentalLength <= 12)
       ) &&
       (
        (this.occupationObject.rentalPriceType === 'F' && this.occupationObject.priceAssessmentYear && this.occupationObject.priceAssessmentLandPrice) ||
        (this.occupationObject.rentalPriceType === 'E' && this.occupationObject.rentalExpertOpinionNumber && this.occupationObject.rentalExpertOpinionDate && this.occupationObject.rentalExpert && this.occupationObject.priceAssessmentLandPrice) ||
        (this.occupationObject.rentalPriceType === 'O' && this.occupationObject.rentalOtherPriceSource && ((this.occupationObject.rentalPriceUnit === 'T' && this.occupationObject.totalRentPrice >= 0) || (this.occupationObject.rentalPriceUnit === 'A' && this.occupationObject.priceAssessmentLandPrice >= 0)))
      )
    );
  }

  occupationLongerThanOneYear() {
    return this.occupationObject.occupationType.category === 'overOneYear';
  }

  occupationShorterThanOneYear() {
    return this.occupationObject.occupationType.category === 'underOneYear';
  }
}

